import { render, staticRenderFns } from "./Part-3.vue?vue&type=template&id=04e5cf59&"
import script from "./Part-3.vue?vue&type=script&lang=js&"
export * from "./Part-3.vue?vue&type=script&lang=js&"
import style0 from "./Part-3.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Part-3.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports